/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import {
  db,
  firebase,
  usersCollection,
} from '../../../firebase'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  fetchCouponList: (req, { uid }) => new Promise((resolve, reject) => {
    if (uid) {
      usersCollection.doc(uid).collection('coupons')
        .where('status', '!=', 'deleted')
        .get()
        .then(snapshot => {
          const list = []
          snapshot.forEach(doc => {
            list.push({ ...doc.data(), ...{ cpid: doc.id } })
          })

          resolve(list)
        })
        .catch(error => {
          reject(error)
        })
    } else {
      reject(new Error('Missing uid'))
    }
  }),
  createCoupon: async (req, params) => {
    // status: [active, deleted, inactive, suspended]
    const { uid, code } = params
    if (uid && code) {
      const update = {
        uid,
        startDateTime: (params.startDateTime && params.startDateTime !== '') ? new Date(params.startDateTime) : null,
        endDateTime: (params.endDateTime && params.endDateTime !== '') ? new Date(params.endDateTime) : null,
        offerType: params.offerType,
        offerName: params.offerName,
        maximumTotalUsage: params.maximumTotalUsage,
        perCustomer: params.perCustomer,
        discountAmount: params.discountAmount,
        description: params.description,
        code,
        campaigns: params.campaigns,
        status: 'active',
        createAt: firebase.firestore.FieldValue.serverTimestamp(),
        updateAt: firebase.firestore.FieldValue.serverTimestamp(),
      }

      const couponRef = usersCollection.doc(uid).collection('coupons').doc(code)

      return db.runTransaction(async transaction => transaction.get(couponRef).then(snapshot => {
        if (!snapshot.exists) {
          transaction.set(couponRef, update)
        }
      }))
    }
    return new Error('Missing uid and code')
  },
  updateCouponData: async (req, { uid, cpid, params }) => {
    if (cpid && uid && params) {
      const update = { ...params }

      if (update.startDateTime) {
        update.startDateTime = (update.startDateTime && update.startDateTime !== '') ? new Date(update.startDateTime) : null
      }

      if (update.endDateTime) {
        update.endDateTime = (update.endDateTime && update.endDateTime !== '') ? new Date(update.endDateTime) : null
      }

      if (update.code) {
        delete update.code
      }

      update.updateAt = firebase.firestore.FieldValue.serverTimestamp()

      await usersCollection.doc(uid).collection('coupons').doc(cpid).set(update, { merge: true })
    }
  },
  updateCouponStatus: async (req, { uid, cpid, status }) => {
    const couponStatus = ['active', 'deleted', 'inactive', 'suspended']
    if (cpid && couponStatus.includes(status)) {
      const update = {
        status,
        updateAt: firebase.firestore.FieldValue.serverTimestamp(),
      }
      await usersCollection.doc(uid).collection('coupons').doc(cpid).set(update, { merge: true })
    }
  },
}

export default {
  state,
  mutations,
  getters,
  actions,
}
